import React from 'react';

import { List } from './List';
import { View } from './View';

export const reportsRoutes = {
  path: '/reports',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: ':id/view',
      element: <View />,
    },
  ],
};
